import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemoteControlPanelComponent } from 'components/work-item-lane-list/work-item-lane/work-item-widget/chat-widget/remote-control-panel/remote-control-panel.component';
import { RemoteControlComponent } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/components/remote-control';
import { ChatViewerModule } from 'shared/components/chat-viewer/chat-viewer.module';
import { WebConsoleContainerModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/shared/components/web-console-container/web-console-container.module';

@NgModule({
  imports: [
    CommonModule,
    ChatViewerModule,
    WebConsoleContainerModule
  ],
  declarations: [
    RemoteControlPanelComponent,
    RemoteControlComponent
  ],
  exports: [
    RemoteControlPanelComponent
  ]
})
export class RemoteControlPanelModule {}
